import { Building2 } from "lucide-react"
import { PlaceholderPage } from "./placeholder-page"

export function CompanyProfilePage() {
  return (
    <PlaceholderPage
      icon={Building2}
      title="Profil firmy"
      description="Edytuj nazw\u0119 firmy, logo, adres i dane kontaktowe Twojej organizacji."
    />
  )
}
